import { render, staticRenderFns } from "./QuestionIcon.vue?vue&type=template&id=42623e4c&scoped=true&"
import script from "./QuestionIcon.vue?vue&type=script&lang=ts&"
export * from "./QuestionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42623e4c",
  null
  
)

export default component.exports